import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer>
      <Container>
        <Row>
          <Col className='text-center' style={{ paddingTop: '0.2rem', paddingBottom: '0.2rem' }}>Copyright &copy; Lotustor
          
          
          </Col>
          

        </Row>
        <Row>
          <Col className='text-center' style={{ paddingTop: '0.2rem', paddingBottom: '0.2rem' }}>
          
          <Link to='/contact'>Contact Us</Link>
          </Col>
          

        </Row>

        
      </Container>
    </footer>
  )
}

export default Footer
